import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import authMiddleware from './middlewares/auth';
import { rootReducer } from './combaineReducers';
import client from '../client';
import NetworkService from './services/networkService';
import history from './createHistory';
import { VALIDATE_TOKEN, LOG_OUT} from './auth/types';

const options = { client, validateAction: VALIDATE_TOKEN, logoutAction: LOG_OUT };
const composeEnhancers = (
  /* eslint-disable no-underscore-dangle */
  process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : null || compose
);

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, authMiddleware(options))),
);

NetworkService.setupInterceptors(store, history);

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./reducers', () => {
    console.log('reducers change')
    const nextReducer = require('./reducers').default
    store.replaceReducer(nextReducer);
  });
}

export default store;



// WEBPACK FOOTER //
// ./src/store/configureStore.js